export default "https://cdn-static.gokick.com/assets/45a1ec4753cb63ac9804059da02cc099817f84d7/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";